import {
  IS_VERCEL_PROD,
  VERCEL_BRANCH_URL,
  minisiteOriginBySlug,
  IS_MAIN_BRANCH,
  PROD_DOMAIN,
  STAGING_DOMAIN,
} from '@monoimin/constants';
import { getLocalePrefix } from '@monoimin/intl';

import type { Locales } from '@monoimin/sb-types';

export const getUrlOrigin = (locale?: Locales, site?: MiniSlug): string => {
  const pathnamePrefix = getLocalePrefix(locale || 'en');

  if (site) {
    return `${minisiteOriginBySlug[site]}${pathnamePrefix}`;
  }

  if (IS_MAIN_BRANCH && STAGING_DOMAIN) {
    return `https://${STAGING_DOMAIN}${pathnamePrefix}`;
  }

  if (IS_VERCEL_PROD && PROD_DOMAIN) {
    return `https://${PROD_DOMAIN}${pathnamePrefix}`;
  }

  if (VERCEL_BRANCH_URL) {
    return `https://${VERCEL_BRANCH_URL}${pathnamePrefix}`;
  }

  if (process.env.BASE_URL) {
    return `${process.env.BASE_URL}${pathnamePrefix}`;
  }

  if (process.env.NEXT_PUBLIC_BASE_URL) {
    return `${process.env.NEXT_PUBLIC_BASE_URL}${pathnamePrefix}`;
  }

  return `http://localhost:4200${pathnamePrefix}`;
};
export default getUrlOrigin;
